'use client';
import { TypeGlobalBannerFields } from '@/core/generated-types';
import React, { FC, useEffect, useState } from 'react';
import { RichText } from '@/components/';
import { Document } from '@contentful/rich-text-types';
import classNames from 'classnames';
import useAuth from '@/context/AuthContext';
import styles from './GlobalBanner.module.scss';
import AccessibilityLink from '@/components/common/AccessibilityLink/AccessibilityLink';

const GlobalBanner: FC<TypeGlobalBannerFields> = ({
  userLoggedOutText,
  userLoggedInText,
  showAccessibilityLink = false,
  enableAccessibilityLabel = 'Enable Accessibility',
  disableAccessibilityLabel = 'Disable Accessibility',
  backgroundColor,
  textColor,
}) => {
  const [hydrated, setHydrated] = useState(false);

  const { user } = useAuth();
  const useLoggedInText = !!user && userLoggedInText;
  const textToDisplay = useLoggedInText ? userLoggedInText : userLoggedOutText;

  useEffect(() => {
    setHydrated(true);
  }, []);

  //  US global banner have a different color than other stores
  const isUSStore = process.env.NEXT_PUBLIC_REGION === 'US';

  return (
    <div
      data-testid="global-banner"
      className={classNames(
        `relative z-10 px-3 py-[10px] md:text-base text-sm min-h-[44px]`,
        backgroundColor
          ? `bg-${backgroundColor.fields?.color}`
          : isUSStore
            ? 'bg-blue-deep'
            : 'bg-aqua',
        textColor
          ? `text-${textColor.fields?.color}`
          : isUSStore
            ? 'text-white'
            : ``,
      )}
    >
      {textToDisplay && hydrated && (
        <div
          className={classNames(
            showAccessibilityLink
              ? 'w-[60%] text-left lg:w-full md:text-center'
              : 'w-full text-center',
            styles.bannerStyle,
            styles.stripLinkColor,
          )}
        >
          <RichText
            openLinkSameWindow={true}
            content={textToDisplay as Document}
          />
        </div>
      )}

      {showAccessibilityLink && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2 transform text-right md:w-auto">
          <AccessibilityLink
            enableAccessibilityLabel={enableAccessibilityLabel}
            disableAccessibilityLabel={disableAccessibilityLabel}
          />
        </div>
      )}
    </div>
  );
};

export default React.memo(GlobalBanner);
